import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import { groupJsonByVal } from '../../utils/groupJsonByVal';

const firebaseRef = firebase.database();

export async function getAllReportInfo(callback) {
	firebaseRef
		.ref('/kavtek_report_information/' + PROJECT_CODE.projectCode)
		.on('value', (snapshot) => {
			var reports = snapshot.val();

			var reportsArr = [];
			var reportsKeys = Object.keys(reports);

			reportsKeys.forEach((key, index) => {
				var report = reports[key];

				report['index'] = index;

				reportsArr.push(report);
			});
			console.log('reporeportsrts', reportsArr);

			// reduce iterates over each item, using accumulator
			var builtObj = groupJsonByVal(reportsArr, 'category_id');

			callback(builtObj);
		});
}
